<template>
  <div>
    <b-form-group>
      <label class="idx-bold">{{
        $t('newAction.stepOne.labels.collectionCanal')
      }}</label>
      <b-form-radio-group
        id="type-radio-group"
        name="radio-sub-component"
        :value="action.channel"
        v-model="action.channel"
      >
        <b-form-radio name="email-radio" value="email">E-mail</b-form-radio>
        <b-form-radio v-if="company.channelWhatsApp" name="email-wpp-radio" value="email/whatsapp">E-mail/Whatsapp</b-form-radio>
        <b-form-radio name="sms-radio" value="sms">SMS</b-form-radio>
        <b-form-radio name="emailsms-radio" value="emailsms"
          >Email/SMS</b-form-radio
        >
        <b-form-radio name="widget-radio" value="widget">Widget</b-form-radio>
        <b-form-radio name="qrcode-radio" value="qrcode">Qr Code</b-form-radio>
        <b-form-radio name="link-radio" value="link">Link</b-form-radio>
        <template v-if="company.channelTotem">
          <b-form-radio name="totem-radio" value="totem">Totem</b-form-radio>
        </template>
        <template v-if="company.channelCallCenter">
          <b-form-radio name="click-to-call" value="click-to-call"
            >Click-to-call</b-form-radio
          >
        </template>
        <template v-if="company.channelWhatsApp">
          <b-form-radio name="whatsapp" value="whatsapp">Whatsapp</b-form-radio>
        </template>
      </b-form-radio-group>
    </b-form-group>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions('actions', ['setChannel', 'setSmsConfig']),
  },

  computed: {
    ...mapState('actions', ['action']),
    ...mapState('companies', ['company']),
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/molecules/action-channel/index.vue